import { gql } from '@apollo/client';

export default gql`
  mutation addAdditionalDetails($bookingReference: String!, $additionalDetails: [InputAdditionalDetails]!) {
    addAdditionalDetails(bookingReference: $bookingReference, additionalDetails: $additionalDetails) {
      reference
    }
  }
`;
